module.exports = __webpack_public_path__ + "slide-prev-dark-icon-18e994510d0a403abb56.svg";